import React, { useContext } from "react";
import { motion } from "framer-motion";
import FormContext from "../../../context/forms/FormContext";
import { FaDownload } from "react-icons/fa";

function Formularios({ forms }) {
  const { downloadFormDocumentClient } = useContext(FormContext);

  const handleFormDownload = (id) => downloadFormDocumentClient(id); // Download form

  return (
    <>
      <div className='text-center py-6 mt-8'>
        <motion.h2
          className='pb-5 text-3xl md:text-5xl lg:text-6xl'
          initial='hidden'
          whileInView='visible'
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          variants={{
            visible: {
              opacity: 1,
              transition: {
                delay: 0.3,
                duration: 0.5,
              },
            },
            hidden: { opacity: 0 },
          }}
        >
          Formularios
        </motion.h2>
        <div className='flex justify-center px-2'>
          <motion.p
            initial='hidden'
            whileInView='visible'
            viewport={{ once: true }}
            variants={{
              visible: {
                opacity: 1,
                transition: {
                  delay: 0.3,
                  duration: 0.5,
                },
              },
              hidden: { opacity: 0 },
            }}
            className='max-w-xl'
          >
            Encuentra aquí todos los formularios que nuestra ASADA ofrece para
            la realización de los diferentes trámites.
          </motion.p>
        </div>
      </div>
      <div className='grid lg:grid-cols-2 xl:grid-cols-3 sm:justify-center gap-5 px-12'>
        {forms.length !== 0 &&
          forms.map((form, i) => {
            return (
              <motion.div
                className='card bg-base-100 shadow-xl'
                key={form.id}
                initial='hidden'
                whileInView='visible'
                viewport={{ once: true }}
                transition={{ delay: i * 0.3 }}
                variants={{
                  visible: {
                    opacity: 1,
                  },
                  hidden: { opacity: 0 },
                }}
              >
                <div className='card-body max-h-64'>
                  <h2 className='card-title justify-center text-center'>
                    {form.nombre}
                  </h2>
                  <p className='flex justify-center overflow-y-auto'>
                    {form.descripcion}
                  </p>
                  <motion.div
                    className='justify-center mt-3 card-actions'
                    initial='hidden'
                    whileInView='visible'
                    viewport={{ once: true }}
                    transition={{ delay: 0.5 }}
                    variants={{
                      visible: {
                        opacity: 1,
                      },
                      hidden: { opacity: 0 },
                    }}
                  >
                    <div className='card-actions'>
                      <button
                        className='btn btn-accent btn-outline btn-sm capitalize'
                        onClick={() => {
                          handleFormDownload(form.id);
                        }}
                      >
                        Descargar&nbsp;
                        <FaDownload />
                      </button>
                    </div>
                  </motion.div>
                </div>
              </motion.div>
            );
          })}
      </div>
    </>
  );
}

export default Formularios;
